module.exports = __webpack_public_path__ + "static/media/airbnb.6f948030.svg";